import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { Dimensions, Format } from './constants';
export function debounce(fn, delay) {
  var timer = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      return fn.apply(void 0, args);
    }, delay);
  };
}
export function prepareDimensions(dimensions) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Format.HORIZONTAL;
  var canBeLower = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!dimensions || !dimensions.length) return Dimensions[format] || [];
  if (dimensions.length === 1 && canBeLower) {
    var dimension = dimensions[0];
    var key = "".concat(dimension[0], "x").concat(dimension[1]);
    if (Dimensions[key]) return Dimensions[key] || [];
  }
  return dimensions;
}
var nextId = 0;
export function getNextId() {
  nextId += 1;
  return "rgpt-".concat(nextId);
}
export function loadScript() {
  var gads = document.createElement('script');
  gads.async = true;
  gads.type = 'text/javascript';
  gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
  var head = document.getElementsByTagName('head')[0];
  head.appendChild(gads);
}
export function log() {
  var _console;
  if (isPreRelease) (_console = console).log.apply(_console, arguments);
}
export function checkConsentPurpose1() {
  return new Promise(function (resolve, reject) {
    if (typeof __tcfapi !== 'function') {
      return reject(new Error('__tcfapi no está disponible'));
    }
    __tcfapi('getTCData', 2, function (tcData, success) {
      var _tcData$purpose;
      if (!success || !(tcData !== null && tcData !== void 0 && (_tcData$purpose = tcData.purpose) !== null && _tcData$purpose !== void 0 && _tcData$purpose.consents)) {
        return reject(new Error('No se pudo obtener el consentimiento'));
      }
      var hasConsented = tcData.purpose.consents[1] === true;
      resolve(hasConsented);
    });
  });
}